export default __webpack_public_path__ + "static/media/pc_background2@2x.19fb3e33.png";